import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="34" height="34" rx="4" fill="#C7BCE4" fillOpacity="0.1" />
    <path
      d="M22.8333 9.5H11.1667C10.2462 9.5 9.5 10.2462 9.5 11.1667V22.8333C9.5 23.7538 10.2462 24.5 11.1667 24.5H22.8333C23.7538 24.5 24.5 23.7538 24.5 22.8333V11.1667C24.5 10.2462 23.7538 9.5 22.8333 9.5Z"
      stroke="#7876C1"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.084 15.3333C14.7743 15.3333 15.334 14.7737 15.334 14.0833C15.334 13.393 14.7743 12.8333 14.084 12.8333C13.3936 12.8333 12.834 13.393 12.834 14.0833C12.834 14.7737 13.3936 15.3333 14.084 15.3333Z"
      stroke="#7876C1"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.4994 19.5L20.3327 15.3333L11.166 24.5"
      stroke="#7876C1"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DefaultImageIcon = (props) => <Icon component={svg} {...props} />;

export default DefaultImageIcon;
